import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { OpsgenieTeamReadView } from '@atlassian/jira-servicedesk-insight-attribute-views/src/ui/opsgenie-team/index.tsx';
import type { CmdbObjectAttributeOpsgenieTeam } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export type Props = {
	attribute: CmdbObjectAttributeOpsgenieTeam;
};

export const OpsgenieTeamAttribute = (props: Props) => {
	const { attribute } = props;

	return (
		<Wrapper>
			{attribute.objectAttributeValues.map(({ opsgenieTeam: { id, avatarUrl, name, url } }) => (
				<OpsgenieTeamReadView key={id} id={id} url={url} avatarUrl={avatarUrl} name={name} />
			))}
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexWrap: 'wrap',
	gap: token('space.100'),
});
